import { CONFIG } from '../../core/config';
import { ICell, IColumn } from '../../viewmodels/runnableLookups/icell';
import { Unit } from '../../viewmodels/unit';
import { LookupColumnDataType } from '../lookups/lookup-column-data-type';
import { ViewModel } from '../view-model';
import { RunnableLookupItem } from './runnable-lookup-item';
import { RunnableLookupCell } from './runnableLookups-cell';
import { RunnableLookupItemState } from './runnable-lookup-item-state';

export class RunnableLookupColumn implements ViewModel, IColumn, RunnableLookupItem {
  readonly friendlyTypeNameSingular = 'RunnableLookup Column';
  readonly apiRoute: string = CONFIG.apiRoutes.runnableLookupColumns;

  lookupColumnId: string;
  columnIndex: number;
  identifier: string;
  headerText: string;
  dataType: LookupColumnDataType;
  isDisplayColumn: boolean;
  unitOfMeasure: Unit;
  displayedUnitOfMeasure: Unit;
  uomName: string;
  displayedUomName: string;
  selectedRadioValue: string;

  cells: ICell[] = [];

  lookupId: string;
  public state: RunnableLookupItemState = RunnableLookupItemState.Unchanged;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.lookupColumnId = data.lookupColumnId;
    this.columnIndex = data.columnIndex;
    this.identifier = data.identifier;
    this.headerText = data.headerText;
    this.dataType = data.dataType;
    this.isDisplayColumn = data.isDisplayColumn;
    this.unitOfMeasure = new Unit();
    if (data.unitOfMeasure) {
      this.unitOfMeasure.loadFromJson(data.unitOfMeasure);
      this.uomName = this.unitOfMeasure.uomName;
    } else {
      this.uomName = '(none)';
    }
    this.displayedUnitOfMeasure = new Unit();
    if (data.displayedUnitOfMeasure) {
      this.displayedUnitOfMeasure.loadFromJson(data.displayedUnitOfMeasure);
      this.displayedUomName = this.displayedUnitOfMeasure.uomName;
    } else {
      this.displayedUomName = '(none)';
    }

    if (data.lookupCells) {
      data.lookupCells.forEach(cell => {
        const newCell = new RunnableLookupCell();
        newCell.loadFromJson(cell);
        this.cells.push(newCell);
      });
    }

    this.lookupId = data.lookupId;

    this.selectedRadioValue = data.selectedRadioValue;
  }
}
